import SectorsList from '../layout/pages/SectorsCards.vue'
import { createStore } from 'vuex'
import EventService from '../service/event.service'
import { mapIdTitleToValueName } from '@/modules/utils/simpleSelect'

const createDefaultClassDraft = () => ({
  id: Date.now(),
  title: null,
  module_id: null,
  module_title: null,
  video_url: null,
  video_id: null,
  min_grade_required: null,
  questions: []
})

const createDefaultEvent = () => ({
  id: null,
  title: null,
  description: null,
  banner: null,
  bannerName: null,
  tag: null,
  integrantes: [],
  classDraft: createDefaultClassDraft(),
  classes: []
})

const cloneDeep = (value) => JSON.parse(JSON.stringify(value))

export const dataEvent = createStore({
  state: () => {
    return {
      allEvents: [],
      allFighters: [],
      questionCollect: [],

      events: createDefaultEvent(),
      modules: [],
      questions: [],

      has_question: false,
      has_minimum_grade: false,
      activeClassEditIndex: null,

      selectedFighter: null,

      componentActive: SectorsList,
      backToComponent: 'SectorsList',
      pageTitle: 'SETORES',
      pageSubTitle: 'Gerencie seus sistema de emergência por setores',
      buttonActive: true,

      // component anterior
      sectors: [],
      sectorId: undefined,
      itemsBySector: [],
      sectorForm: {
        title: undefined,
        category: undefined,
        resum: undefined,
        banner: undefined,
        content: undefined
      },
      itensForm: {
        name: undefined,
        type: undefined,
        category: undefined,
        values: {},
        images: undefined,
        imagesName: undefined,

        description: undefined,
        check_every: undefined,
        next_check: undefined,
        th_expiration: undefined,
        validity_expiration: undefined
      },
      maintenanceForm: {
        type: undefined,
        values: {},
        checklist: [],
        carried_out_in: undefined,
        images: undefined,
        imagesName: undefined
      },

      questionsCollect: [],
      question: {
        title: null,
        options: []
      }
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    backToComponent: (state) => state.backToComponent,
    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
    getIfButtonActive: (state) => state.buttonActive,
    getSectors: (state) => state.sectors,
    getItensBySector: (state) => state.itemsBySector,
    getAllEvents: (state) => state.allEvents,
    getAllFighters: (state) => state.allFighters,
    draftQuestions: s => s.events.classDraft.questions,
    classesCount: s => s.events.classes.length,
    questionsCount: (s, g) => g.draftQuestions.length,
    classDraft: (s) => s.events.classDraft,
    classes: (s) => s.events.classes,
    trainingToRegister: (s) => s.events,
    getQuestionCollect: (s) => s.questionCollect,
    activeClassEditIndex: (s) => s.activeClassEditIndex,
    isEditingClass: (s) => s.activeClassEditIndex !== null
  },
  mutations: {
    RESET_MAINTENANCE (state) {
      state.maintenanceForm.values.motivo = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.imagesName = undefined
      state.maintenanceForm.values.images = undefined

      state.maintenanceForm.checklist = []
      state.maintenanceForm.carried_out_in = undefined
      state.maintenanceForm.images = undefined
      state.maintenanceForm.imagesName = undefined
    },
    RESET_FORM (state) {
      state.events = createDefaultEvent()
    },
    RESET_TRAINING_STATE (state) {
      state.events = createDefaultEvent()
      state.has_question = false
      state.has_minimum_grade = false
      state.selectedFighter = null
      state.activeClassEditIndex = null
    },
    RESET_QUESTIONS_MODAL (state) {
      state.question.title = null
      state.question.options = []
    },
    SET_COMPONENT_ACTIVE (state, value) {
      state.componentActive = value
    },
    SET_ALL_EVENTS (state, value) {
      state.allEvents = []
      state.allEvents = value
    },
    SET_ALL_FIGHTERS (state, value) {
      state.allFighters = []
      state.allFighters = value
    },
    SET_PAGE_TITLE (state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE (state, value) {
      state.pageSubTitle = value
    },
    SET_IF_BUTTON_ACTIVE (state, value) {
      state.buttonActive = value
    },
    SET_BACK_COMPONENT (state, value) {
      state.backToComponent = value
    },
    SET_ITENS_BY_SECTOR (state, value) {
      state.itemsBySector = []
      state.itemsBySector = value
    },
    NEW_ITEM_BY_SECTOR (state, payload) {
      state.itemsBySector.unshift(payload)
    },
    NEW_EVENT_ITEM (state, value) {
      state.allEvents.unshift(value)
    },
    SET_MAINTENANCES (state, value) {
      state.itensForm.maintenances = []
      state.itensForm.maintenances = value
    },
    SET_ITEM_TO_EDIT (state, value) {
      const data = { ...value }

      if (
        data.values != null ||
        data.values != [null] || data.values != '[null]' ||
        data.values != [[]] || data.values != '[[]]'
      ) {
        try {
          const parsed = JSON.parse(data.values)
          data.values = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : {}
        } catch (error) {
          console.error('Erro ao fazer parse do JSON:', error)
          data.values = {}
        }
      }

      state.itensForm = data
    },
    SET_TRAINING_TO_EDIT (state, payload) {
      const classes = Array.isArray(payload?.classes) ? cloneDeep(payload.classes) : []
      const integrantes = Array.isArray(payload?.integrantes) ? cloneDeep(payload.integrantes) : []

      state.events = {
        ...createDefaultEvent(),
        ...cloneDeep(payload),
        bannerName: payload?.bannerName ?? payload?.banner ?? null,
        classDraft: createDefaultClassDraft(),
        classes,
        integrantes
      }

      state.has_question = false
      state.has_minimum_grade = false
      state.activeClassEditIndex = null
    },
    ADD_INTEGRANTE (state, payload) {
      if (!state.events.integrantes) {
        state.events.integrantes = []
      }
      state.events.integrantes.push(payload)
    },
    SET_DRAFT_FIELD (state, { key, value }) {
      state.events.classDraft[key] = value
    },
    RESET_DRAFT (state) {
      state.events.classDraft = createDefaultClassDraft()
      state.activeClassEditIndex = null
    },
    SET_CLASS_EDIT_INDEX (state, index) {
      state.activeClassEditIndex = index
    },
    SET_HAS_QUESTION (state, value) {
      state.has_question = value

      if (!value?.value) {
        state.events.classDraft.questions = []
        state.events.classDraft.min_grade_required = null
        state.has_minimum_grade = false
      }
    },
    SET_HAS_MINIMUM_GRADE (state, value) {
      state.has_minimum_grade = value

      if (!value?.value) {
        state.events.classDraft.min_grade_required = null
      }
    },
    ADD_DRAFT_QUESTION (state, q) {
      state.events.classDraft.questions.push(q)
    },
    UPDATE_DRAFT_QUESTION (state, { index, patch }) {
      Object.assign(state.events.classDraft.questions[index], patch)
    },
    REMOVE_DRAFT_QUESTION (state, index) {
      state.events.classDraft.questions.splice(index, 1)
    },
    ADD_CLASS_FROM_DRAFT (state) {
      const clone = cloneDeep(state.events.classDraft)
      if (!clone.id) clone.id = Date.now()
      state.events.classes.push(clone)
    },
    UPDATE_CLASS_FROM_DRAFT (state, index) {
      if (index === null || index === undefined || !state.events.classes[index]) return

      const clone = cloneDeep(state.events.classDraft)
      if (!clone.id) clone.id = state.events.classes[index]?.id ?? Date.now()
      state.events.classes.splice(index, 1, clone)
      state.activeClassEditIndex = null
    },
    REMOVE_CLASS (state, index) {
      state.events.classes.splice(index, 1)

      if (state.activeClassEditIndex === index) {
        state.activeClassEditIndex = null
      }
    },
    REORDER_CLASSES (state, { fromIndex, toIndex }) {
      if (
        fromIndex === toIndex ||
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= state.events.classes.length ||
        toIndex >= state.events.classes.length
      ) {
        return
      }

      const moved = state.events.classes.splice(fromIndex, 1)[0]
      state.events.classes.splice(toIndex, 0, moved)
    },
    SET_QUESTION_COLLECT (state, payload) {
      state.questionCollect = payload
    }
  },
  actions: {
    resetForm ({ commit }) {
      commit('RESET_FORM')
    },
    resetTrainingState ({ commit }) {
      commit('RESET_TRAINING_STATE')
    },
    setAllEvents ({ commit }, val) {
      commit('SET_ALL_EVENTS', val)
    },
    setAllFighters ({ commit }, val) {
      commit('SET_ALL_FIGHTERS', val)
    },
    setComponentActive ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setPageTitle ({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle ({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },
    setButtonActive ({ commit }, value) {
      commit('SET_IF_BUTTON_ACTIVE', value)
    },
    setBackComponent ({ commit }, value) {
      commit('SET_BACK_COMPONENT', value)
    },
    setItemsBySector ({ commit }, value) {
      commit('SET_ITENS_BY_SECTOR', value)
    },
    addNewEventCollect ({ commit }, value) {
      commit('NEW_EVENT_ITEM', value)
    },
    newItemBySector ({ commit }, value) {
      commit('NEW_ITEM_BY_SECTOR', value)
    },
    setItemToEdit ({ commit }, value) {
      commit('SET_ITEM_TO_EDIT', value)
    },
    setTrainingToEdit ({ commit }, value) {
      commit('SET_TRAINING_TO_EDIT', value)
    },
    setMaintenances ({ commit }, value) {
      commit('SET_MAINTENANCES', value)
    },
    resetMaintenanceForm ({ commit }) {
      commit('RESET_MAINTENANCE')
    },
    async getComboQuestion ({ commit }) {
      await EventService.getComboQuestions()
        .then(res => {
          const data = mapIdTitleToValueName(res.data)
          commit('SET_QUESTION_COLLECT', data)
        }).catch(err => {
          console.log(err)
        })
    },
    setDraftField: ({ commit }, p) => commit('SET_DRAFT_FIELD', p),
    resetDraft: ({ commit }) => commit('RESET_DRAFT'),
    setClassEditIndex: ({ commit }, index) => commit('SET_CLASS_EDIT_INDEX', index),
    setHasQuestion: ({ commit }, value) => commit('SET_HAS_QUESTION', value),
    setHasMinimumGrade: ({ commit }, value) => commit('SET_HAS_MINIMUM_GRADE', value),
    addDraftQuestion: ({ commit }, q) => commit('ADD_DRAFT_QUESTION', q),
    updateDraftQuestion: ({ commit }, p) => commit('UPDATE_DRAFT_QUESTION', p),
    removeDraftQuestion: ({ commit }, i) => commit('REMOVE_DRAFT_QUESTION', i),
    addClassFromDraft: ({ commit }) => commit('ADD_CLASS_FROM_DRAFT'),
    updateClassFromDraft: ({ commit }, index) => commit('UPDATE_CLASS_FROM_DRAFT', index),
    removeClass: ({ commit }, i) => commit('REMOVE_CLASS', i),
    reorderClasses: ({ commit }, payload) => commit('REORDER_CLASSES', payload)
  }
})
